module.exports = __webpack_public_path__ + "img/qibiao.2b8beceb.png";